<template>
  <Card class="UserCard">
    <section class="UserCard__inner">
      <Heading heading="ユーザー" type="quaternary" level="2" />
      <dl class="UserCard__info">
        <div class="UserCard__infoItem">
          <dt class="UserCard__label active">{{ messages.user.active }}</dt>
          <dd class="UserCard__number">{{ active }}</dd>
        </div>
        <div class="UserCard__infoItem">
          <dt class="UserCard__label invited">
            {{ messages.user.invited }}
          </dt>
          <dd class="UserCard__number">{{ invited }}</dd>
        </div>
        <div class="UserCard__infoItem">
          <dt class="UserCard__label expired">
            {{ messages.user.expired }}
          </dt>
          <dd class="UserCard__number">{{ expired }}</dd>
        </div>
      </dl>
      <ul class="UserCard__button">
        <li class="UserCard__buttonItem">
          <Button
            tag="button"
            dynamics="tertiary"
            :label="messages.heading.userManagement"
            @click="moveToUserList"
          />
        </li>
        <li class="UserCard__buttonItem">
          <Button
            tag="button"
            dynamics="tertiary"
            :label="messages.heading.userInvitation"
            @click="moveToInvitation"
          />
        </li>
      </ul>
    </section>
  </Card>
</template>

<script>
import Button from '@spectee/components/Atoms/Button/index.vue';
import Card from '@spectee/components/Atoms/Card/index.vue';
import Heading from '@spectee/components/Atoms/Heading/index.vue';
import messages from '../../../messages.json';

export default {
  name: 'UserCard',
  components: { Button, Card, Heading },
  props: {
    active: {
      type: [String, Number],
      default: '',
    },
    invited: {
      type: [String, Number],
      default: '',
    },
    expired: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      messages,
    };
  },
  methods: {
    moveToInvitation() {
      this.$router.push({
        name: 'AdminUsers',
        state: { isInviteUser: true },
      });
    },
    moveToUserList() {
      this.$router.push({
        name: 'AdminUsers',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.UserCard {
  display: flex;
  padding: $service-unit * 4;
  height: $service-unit * 50;

  &__inner {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  &__info {
    display: flex;
    justify-content: flex-start;
    gap: $service-unit * 37;
    margin-top: $service-unit * 3;
  }

  &__infoItem {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__label {
    font-size: $service-font-size-p;

    &.active {
      color: #379248;
    }

    &.invited {
      color: #997d38;
    }

    &.expired {
      color: #da5448;
    }
  }

  &__number {
    align-self: flex-start;
    font-size: $service-font-size-fff;
    font-weight: $service-font-weight-sb;
    line-height: $service-unit * 12;
  }

  &__button {
    display: flex;
    margin-top: auto;
  }

  &__buttonItem:not(:first-child) {
    margin-left: $service-unit * 4;
  }

  @media (max-width: 768px) {
    display: flex;
    padding: $service-unit * 3;

    &__info {
      display: flex;
      flex-grow: 1;
      justify-content: flex-start;
      gap: $service-unit * 4;
      margin-top: $service-unit * 3;
    }
  }
}
</style>
